import {
    TemplatePmsApiService
} from "./template.service";
import {
    SmsTemplate
} from "../models";

export class SmsTemplatePmsApiService extends TemplatePmsApiService {


    get templateType() {

        return this.senderOption || "sms-template";
    }

    newModel(attributes, ...params) {

        return new SmsTemplate(attributes);
    }

    sendTestSms(template, recipients) {

        const url = this.url({
            propertyId: template.property.id,
            id: template.id,
            option: 'send-test-sms'
        });

        this.http.post(url, { recipients: recipients }, {
            headers: this.authHeaders,
        }).then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    updateSenderName(property, name) {

        this.senderOption = "update-sender"

        const url = this.url(
            {
                propertyId: property.id,
            }
        );

        delete this.senderOption;

        return this.http.put(url, {name: name}, {
            headers: this.authHeaders,
        }).then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms-template.service.js